import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/homeContent';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 border-b border-background-200 backdrop-blur' : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between md:h-[72px]">
          {/* brand */}
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap">
            <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-xl font-black tracking-tight text-foreground-950">1黑料网</span>
              <span className="mt-1 text-[10px] tracking-[0.25em] text-foreground-500">每日 · 汇总 · 盘点</span>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-7 md:flex">
            {navItems.map((n) => (
              <a
                key={n.anchor}
                href={n.anchor}
                className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 whitespace-nowrap">
              <i className="ri-flashlight-line text-xs"></i>
              今日已更新 68 条
            </span>
            <a
              href="#rank"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              看今日热度
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>

          {/* mobile toggle */}
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 cursor-pointer md:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* mobile menu */}
      <div
        className={`overflow-hidden bg-background-50/98 border-b border-background-200 transition-all duration-300 md:hidden ${
          open ? 'max-h-[420px]' : 'max-h-0 border-b-0'
        }`}
      >
        <nav className="flex flex-col px-6 py-4">
          {navItems.map((n) => (
            <a
              key={n.anchor}
              href={n.anchor}
              onClick={() => setOpen(false)}
              className="border-b border-background-100 py-3 text-sm font-medium text-foreground-800 cursor-pointer"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#rank"
            onClick={() => setOpen(false)}
            className="mt-4 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap cursor-pointer"
          >
            看今日热度
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </nav>
      </div>
    </header>
  );
}